import { z } from 'zod'

export const ResourceSchema = z.object({
  name: z.string().min(1, { message: 'sentences.nameIsRequired' }),
})
